module.exports = __webpack_public_path__ + "static/media/dinghuo-banner.c3452d48.jpg";